// Landing page analytics. Loaded via <script src="/landing.js" defer>.

import { acquisitionProps, trackEvent } from './visitor';

trackEvent('landing_view', acquisitionProps());
